import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

if (environment.production) {
	enableProdMode();
}

window.document.getElementsByTagName("body")[0].style.background = environment.bgColor;

platformBrowserDynamic()
	.bootstrapModule(AppModule)
	.catch((err) => console.error(err));
